export default __webpack_public_path__ + "static/media/Empty State 2x.c12c3b0a.png";